<template>
	<div class="margin-left">
		<p class="text-left margin-bottom-sm">请绑定本人银行卡，用于本平台提现使用</p>
		<!-- <el-form label-width="430px" :model="bankinfo" :rules="rules"> -->
		<div class="demo-ruleForm">
			<el-form :model="bankinfo" label-position="left" status-icon :rules="rules" ref="ruleForm"
				label-width="430px">
				<el-form-item label="姓名">
					<el-input v-model="bankinfo.name" placeholder="请输入您的姓名"></el-input>
				</el-form-item>
				<el-form-item label="卡号">
					<el-input type="number" v-model="bankinfo.bank_number" placeholder="请输入银行卡号"></el-input>
				</el-form-item>
				<el-form-item label="银行选择">
					<el-input v-model="bankinfo.bank" placeholder="请输入银行名称"></el-input>
				</el-form-item>

			</el-form>
		</div>
		<el-button class="creat" type="primary" @click="submitForm('ruleForm')">确认绑定</el-button>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			var checkname = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('姓名不能为空'));
				}
				callback();
			};
			var checkregion = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入卡号'));
				}
				setTimeout(() => {
					if (!Number.isInteger(value)) {
						callback(new Error('请输入数字值'));
					}
					callback();
				}, 1000);
			};
			var checkbank = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('银行名称不能为空'));
				}
				callback();
			};
			

			return {
				bankinfo: {
					name: '',//姓名
					bank_number: '', //卡号
					bank: '', //银行
				}, //
				rules: {
					name: [{
						validator: checkname,
						trigger: 'blur'
					}],
					bank_number: [{
						validator: checkregion,
						trigger: 'blur'
					}],
					bank:[{
						validator: checkbank,
						trigger: 'blur'
					}],
				},//表单验证规则 
				editid:0,
			};
		},
		created() {
			Bus.$on('editdetail',data=>{
				console.log(data);
				this.bankinfo = data
				this.editid = data.id
			})
		},
		destroyed() {
			Bus.$off()
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if(this.editid!= 0){
							this.edit()
						}else{
							this.add()
						}
						
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			edit(){
				let data = this.bankinfo
				data.id = this.editid
				this.ajax('post', '/api/pc/userBank/edit',data, res => {
					console.log(res);
					if(res.status == 200){
						
						this.$message('修改成功');
						
					}else{
						this.$message(res.msg);
					}
				})
			},
			add(){
				let data = this.bankinfo
				
				this.ajax('post', '/api/pc/userBank/add',data, res => {
					console.log(res);
					if(res.status == 200){
						if(res.data&&res.data.code == 202){
							return this.$message.info('您已绑定10张银行卡');
						}
						this.$message('添加成功');
						
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.demo-ruleForm {
		width: 920px;
		
		background: #FFFFFF;
		border-radius: 8px;
	}

	/deep/ .el-form-item {
		border-bottom: 1px solid #F0F0F0;
		padding: 20px;
		margin: 0;
	}

	/deep/ .el-input__inner {
		outline: 0;
		border: 0;
	}

	/deep/ .el-input__inner::-webkit-outer-spin-button,
	/deep/ .el-input__inner::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	/deep/ .el-input__inner[type="number"] {
		-moz-appearance: textfield;
	}
	.creat {
		width: 383px;
		height: 46px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2000);
		border-radius: 23px;
		margin-top: 60px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/wallet/addbank.vue